import React, { Component } from 'react';

class AccountValidateFailure extends Component {
  render() {
    return (
      <div className="p-5 form-container" id="view-validate-local-account-failure">
        <div className="text-center">
          <h1 className="h4 text-gray-900 mb-4">Ο λογαριασμός σου δεν ενεργοποιήθηκε!</h1>
        </div>
        <p className="mb-4">Δε μπορορέσαμε να βρούμε το κλειδί ενεργοποίησης.</p>
        <p className="mb-4">Το κλειδί είναι διαθέσιμο για 4 ώρες και μπορεί να χρησιμοποιηθεί μόνο μια φορά.</p>
      </div>
    );
  }
}

export default AccountValidateFailure;